module.exports = __webpack_public_path__ + "static/img/ic_whatsapp.f343973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/ic_whatsapp.png
// module id = Ft2p
// module chunks = 0